import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'
import URI from 'urijs'
import config from '@/config/env'

import api from '@/api/api'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import DateField from '@/components/general/fields/date/date'

export default {
  name: 'reports-sda',
  data () {
    return {
      SDAsInfo: [],
      filters: {
        since: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        until: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        exported: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.sda.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.exported_options.all'), value: 'all'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.only_exported'), value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.not_exported'), value: 'not_exported'
          }],
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.reports.sda.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.limit_options.10'), value: 10
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.25'), value: 25
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.50'), value: 50
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.100'), value: 100
          }],
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      selectedSDAsInfo: [],
      allChecks: [],
      getSDAsInfoActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      activateAllCheckbox: {
        id: _.uniqueId('field_'),
        display: true,
        error: false,
        value: {
          active: false
        },
        options: {
          active: {
            value: true
          }
        },
        filters: {
          type: 'manyOptions'
        }
      },
      exportDataActive: false
    }
  },
  methods: {
    getSDAsInfo () {
      let vm = this

      vm.getSDAsInfoActive = true
      vm.SDAsInfo = []

      let exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported'

      let since = vm.filters.since.value ? moment(vm.filters.since.value).startOf('day').toDate() : ''
      let until = vm.filters.until.value ? moment(vm.filters.until.value).endOf('day').toDate() : ''

      let dataToSend = '/?state=' + 0 + '&descending=' + 'lastDateSDA' + '&since=' + since + '&until=' + until + '&exported=' + exported + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value + '&virtualSignApproved=false'

      api
        .SDAsInfo
        .getSDAsInfo(dataToSend)
        .then((response) => {
          vm.getSDAsInfoActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')], type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')], type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.SDAsInfo = response.data.SDAsInfo

          _.each(vm.SDAsInfo, function (element) {
            if (element.normalSDA && element.normalSDA.pdf) {
              let uri_org = new URI(element.normalSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.normalSDA.pdf.url = config.api.baseUrl + pathname
            }

            if (element.wedoSDA && element.wedoSDA.pdf) {
              let uri_org = new URI(element.wedoSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.wedoSDA.pdf.url = config.api.baseUrl + pathname
            }

            if (element.systemECSDA && element.systemECSDA.pdf) {
              let uri_org = new URI(element.systemECSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.systemECSDA.pdf.url = config.api.baseUrl + pathname
            }

            if (element.sebastianSDA && element.sebastianSDA.pdf) {
              let uri_org = new URI(element.sebastianSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.sebastianSDA.pdf.url = config.api.baseUrl + pathname
            }
          })

          if (vm.SDAsInfo.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.SDAsInfo.length > vm.filters.limit.value) {
            vm.nextPage = true

            vm.SDAsInfo.pop()
          } else {
            vm.nextPage = false
          }

          vm.allChecks = _.map(vm.SDAsInfo, (SDA) => {
            let field = {
              id: _.uniqueId('field_'),
              display: true,
              error: false,
              value: {},
              options: {},
              filters: {
                type: 'manyOptions'
              }
            }

            field.value[SDA.objectId] = false

            field.options[SDA.objectId] = {}

            return field
          })
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getSDAsInfo()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getSDAsInfo()
      }
    },
    activateAllCheckboxToggle () {
      let vm = this

      vm.selectedSDAsInfo = []

      if (vm.activateAllCheckbox.value.active) {
        for (let i = 0; i < vm.allChecks.length; i++) {
          for (let j in vm.allChecks[i].value) {
            vm.allChecks[i].value[j] = true
          }
        }
      } else {
        for (let i = 0; i < vm.allChecks.length; i++) {
          for (let j in vm.allChecks[i].value) {
            vm.allChecks[i].value[j] = false
          }
        }
      }
    },
    exportData () {
      let vm = this

      let SDAsInfoIds = _.filter(vm.selectedSDAsInfo, (element) => {
        if (!element) {
          return false
        }

        let key = ''

        for (let i in element) {
          key = i
        }

        return element[key]
      })

      SDAsInfoIds = _.map(SDAsInfoIds, (element) => {
        let key = ''

        for (let i in element) {
          key = i
        }

        return key
      })

      if (SDAsInfoIds.length == 0) {
        let message = {
          message: [vm.$t('private.reports.sda.export.no_data')], type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let dataToSend = {
        headers: [vm.$t('private.reports.sda.table.exported'), vm.$t('private.reports.sda.table.client'), vm.$t('private.reports.sda.table.legal_name'), vm.$t('private.reports.sda.table.seller'), vm.$t('private.reports.sda.table.delegation'), // vm.$t("private.reports.sda.table.sda_sp"),
          // vm.$t("private.reports.sda.table.sda_sp_internet"),
          // vm.$t("private.reports.sda.table.sda_sp_men"),
          // vm.$t('private.reports.sda.table.sda_system_ec'),
          vm.$t('private.reports.sda.table.sda_sebastian'),
          // vm.$t("private.reports.sda.table.sda_sebastian_internet"),
          // vm.$t("private.reports.sda.table.sda_ghd"),
          // vm.$t("private.reports.sda.table.sda_wedo"),
          // vm.$t("private.reports.sda.table.sp_date"),
          // vm.$t("private.reports.sda.table.sp_internet_date"),
          // vm.$t("private.reports.sda.table.sp_men_date"),
          // vm.$t('private.reports.sda.table.sp_system_ec_date'),
          vm.$t('private.reports.sda.table.sebastian_date'),
          // vm.$t("private.reports.sda.table.sebastian_internet_date"),
          // vm.$t("private.reports.sda.table.sda_ghd_date"),
          // vm.$t("private.reports.sda.table.sda_wedo_date"),
          vm.$t('private.reports.sda.table.sda_date')],
        SDAsInfoIds,
        timeZone: moment.tz.guess()
      }

      vm.exportDataActive = true

      api
        .reports
        .exportSDA(dataToSend)
        .then((response) => {
          vm.getSDAsInfoActive = false

          vm.exportDataActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')], type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let file = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let fileURL = URL.createObjectURL(file)

          FileSaver.saveAs(file, 'sda.xlsx')

          vm.getSDAsInfo()
        })
    },
    parseDate (date) {
      let _date = _.has(date, 'iso') ? date.iso : date

      return moment(_date).format('DD-MM-YYYY')
    }
  },
  components: {
    MenuMoreOptions, TextField, SelectField, CheckboxField, DateField
  },
  created () {
    let vm = this

    vm.getSDAsInfo()
  }
}



// WEBPACK FOOTER //
// ./src/components/private/reports/sda/script.js